import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  IconButton,
  Popover,
  Checkbox,
} from "@mui/material";
import frame from "../../../../Assets/img/upload-image.png";
import { useParams } from "react-router-dom";
import useApi from "../../../Utilities/useAPI";
import Avatar from "@mui/material/Avatar";
import { ReactComponent as AdminIcon } from "../../../../Assets/img/icons/Admin_icon.svg";
import { FaPlusCircle } from "react-icons/fa";
import AddMemberToGroupCard from "./subComponents/AddMemberToGroupCard";
import useAvailableHeight from "../../../Custom/UseAvailableHeight";
import { ReactComponent as Invite } from "../../../../Assets/img/icons/Invite.svg";
import { ReactComponent as Member } from "../../../../Assets/img/icons/Team Member Hierarchy.svg";
import { FaCircleMinus } from "react-icons/fa6";
import CloseIcon from "@mui/icons-material/Close";
import ProfilePicEditComponent from "../../../Utilities/ProfilePicEditComponent";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import VerifiedIcon from "@mui/icons-material/Verified";
import { ReactComponent as NonVerifiedTickNew } from "../../../../Assets/img/icons/Non-verified-icon.svg";
import { useQuantityContext } from "../../../QuantityContext";
import axios from "axios";
import FamilyDashboard from "./FamilyDashboard";
import {
  deleteGroupcardMemberReducer,
  getAllCardDetailsReducer,
  getAllCardInfoReducer,
  getFamilyCardReducer,
} from "../../../../Redux/Reducers/CardReducer";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Pending from "../../../../Assets/img/card/pending.png";
// import { useNavigate } from 'react-router-dom';

const ProfileCard = ({
  profile,
  isEdit,
  level,
  handleDivClick,
  handleProfileClick,
}) => (
  <div
    className={`profile-card level-${level} d-flex align-items-center p-3 gap-2`}
    onClick={() => {
      handleProfileClick(profile);
    }}
  >
    <div className="leftside_image_groupTree" style={{ position: "relative" }}>
      <div className="img flex-center" style={{ padding: "2px" }}>
        <Avatar
          sx={{ width: 54, height: 54 }}
          alt={profile.userDetails.first_name}
          src={profile.userDetails.profile_url} // If image is needed, otherwise remove this line
        />
        <div className={`symbol_of_contacts2_list compact`}>
          {profile.userDetails.is_verified === 1 ? (
            <VerifiedIcon style={{ color: "#43A047" }} />
          ) : (
            <NonVerifiedTickNew />
          )}
        </div>
      </div>
    </div>

    <div className="d-flex flex-column">
      <div>{profile.userDetails.first_name}</div>
      <div className="text-start">{profile.relationship}</div>
    </div>

    {profile.role === "ADMIN" ? (
      <div className="plus_adding_memb icon-20px">
        <AdminIcon />
      </div>
    ) : (
      <div className="plus_adding_memb icon-20px">
        {profile?.status === "PENDING" ? (
          <img src={Pending} alt="Pending" width="20px" height="20px" />
        ) : (
          ""
        )}
      </div>
    )}

    {profile.role === "ADMIN" && isEdit && (
      <div className="group_member_add flex-center">
        <div
          className="iconBreadcrumb flex-center ms-0"
          onClick={(e) => {
            e.stopPropagation(); //  prevents parent onClick
            handleDivClick(e.currentTarget);
          }}
        >
          <FaPlusCircle className="icon-color" />
        </div>
      </div>
    )}
  </div>
);

const GroupCard = () => {
  const { id } = useParams();
  // console.log("ID in the Group card", id);

  const { callApiFunction } = useApi();
  const dispatch = useDispatch();
  const { openSnackbar, setGroupId } = useQuantityContext();
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElPopover, setAnchorElPopover] = useState(null);
  const [groupDetailsSideView, setgroupDetailsSideView] = useState(false); // Sidebar visibility
  const [availableHeight1, Column1Ref] = useAvailableHeight(140);
  const [InviteLightBox, setInviteLightBox] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [completeGroupData, setCompleteGroupData] = useState({});
  const [groupMemberDelete, setGroupMemberDelete] = useState(false);
  // const [deleteMember, setDeleteMember] = useState(null);
  const [isVisisble, setIsVisible] = useState(false);

  const handleProfileClick = (profile) => {
    setSelectedProfile(profile);
    setSelectedMember(profile);
    setGroupMemberDelete(true);
    setgroupDetailsSideView(false);
    setIsLightboxOpen(true);
    // setGroupMemberDelete(false);
  };

  const handleCloseLightbox = () => {
    setIsLightboxOpen(false);
    setSelectedProfile(null);
  };

  const groupcardreduxresponse = useSelector(
    (state) => state?.CardArray?.groupcard?.data?.data
  );
  const groupcardreduxresponseisEdit = useSelector(
    (state) => state?.CardArray?.groupcard?.data?.is_editable
  );
  // console.log("groupcardreduxresponsegroupcardreduxresponse", groupcardreduxresponse);
  const [groupData, setGroupData] = useState(groupcardreduxresponse);

  const [isEditable, setIsEditGroup] = useState(groupcardreduxresponseisEdit);

  const handlePopoverClose = () => {
    console.log("Closing Popover");
    setAnchorElPopover(null); // This should close the popover
  };

  const formatDateAndTime = (createdAt) => {
    const date = new Date(createdAt);

    // Format time as 12-hour format with AM/PM
    const timeFormatter = new Intl.DateTimeFormat("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
    const formattedTime = timeFormatter.format(date); // e.g., 12:42 PM

    // Format date as DD Month YYYY
    const dateFormatter = new Intl.DateTimeFormat("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
    let formattedDate = dateFormatter.format(date); // e.g., 13 May 2024
    const [day, month, year] = formattedDate.split(" ");

    const abbreviatedMonth =
      month.length > 4 ? month.slice(0, 3).toUpperCase() : month;

    formattedDate = `${day} ${abbreviatedMonth} ${year}`; // e.g., 13 Sept 2024

    return { formattedTime, formattedDate };
  };
  const [unverifiedMembers, setUnverifiedMembers] = useState([]);

  useEffect(() => {
    if (groupcardreduxresponse) {
      setGroupData(groupcardreduxresponse);
    }
  }, [groupcardreduxresponse]);

  useEffect(() => {
    if (!id) return;

    const fetchGroups = async () => {
      try {
        // const response = await callApiFunction('getGroupCardDetails', { id });
        // console.log("completeGroup data inside the condition", response);
        const reduxresponse = await dispatch(getFamilyCardReducer(id));
        console.log("reduxresponsereduxresponse", reduxresponse?.payload?.data);
        if (reduxresponse?.payload?.data?.statusCode === 200) {
          setGroupId(id);
          setIsEditGroup(reduxresponse?.payload?.data?.is_editable);
          setGroupData(reduxresponse?.payload?.data?.data);

          await dispatch(getAllCardDetailsReducer());
          await dispatch(getAllCardInfoReducer());
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };
    fetchGroups();
  }, [id]);

  useEffect(() => {
    if (groupData?.members) {
      setUnverifiedMembers(groupData?.members);
    }
  }, [groupData]);

  useEffect(() => {
    console.log("Updated Group Data:", groupData);
  }, [groupData]);

  if (!groupData?.group_id) {
    return <div>Loading...</div>;
  }

  const handleCloseSidebar = () => {
    setgroupDetailsSideView(false);
  };

  const handleDeleteSidebar = () => {
    setGroupMemberDelete(false);
  };

  // Helper functions to get members by role or relationship
  const getMemberByRelationship = (relationship) =>
    groupData?.members.find((member) => member?.relationship === relationship);

  const getMembersByRelationship = (relationship) =>
    groupData?.members.filter(
      (member) => member?.relationship === relationship
    );

  const getMembersByAdmin = () =>
    groupData?.members.filter((member) => member?.role === "ADMIN");

  // Retrieve specific members
  const father = getMemberByRelationship("FATHER");
  const mother = getMemberByRelationship("MOTHER");
  const owner = getMemberByRelationship("OWNER");
  const spouse = getMemberByRelationship("SPOUSE");
  const kids = getMembersByRelationship("KID");

  // Handle the div click, which opens the popup
  const handleDivClick = (anchorEl) => {
    setGroupMemberDelete(false);
    setAnchorEl(anchorEl);
  };

  const handleOpenGroupDetails = () => {
    setgroupDetailsSideView(!groupDetailsSideView);
    setGroupMemberDelete(false);
  };

  const handleInviteClick = async (email) => {
    const reqBody = { emailList: [email], name: "" }; // API request body
    try {
      const response = await callApiFunction("inviteMultipleEmails", reqBody);
      if (response.success) {
        // Update state to mark the member as invited
        setUnverifiedMembers((prevState) =>
          prevState.map((m) =>
            m.userDetails.email === email ? { ...m, send: true } : m
          )
        );

        openSnackbar("Invite Sent Successfully", "success");
      } else {
        // If response is not successful, treat it as a failure
        openSnackbar("Try Again Later!", "error");
      }
    } catch (error) {
      console.error("Failed to send invite:", error);
      // Failure case
      openSnackbar("Try Again Later!", "error");
    }
  };

  return (
    <>
      <div className="professional-card-view w-100">
        <div
          className="card_consent_page_left d-flex my-3 mx-3 w-100"
          style={{ backgroundColor: "#ffff", overflow: "hidden" }}
        >
          <div
            className="d-flex flex-column align-items-center w-100 h-100"
            ref={Column1Ref}
            style={{
              maxHeight: `${availableHeight1}px`,
              minHeight: `${availableHeight1}px`,
              overflowY: "auto",
              scrollbarWidth: "none",
            }}
          >
            <div className="w-100 d-flex align-items justify-content-end mt-2 gap-3">
              {isEditable && (
                <>
                  <div
                    className={`icon-20px flex-center-between icon-textGap-6px ${
                      InviteLightBox ? "color-blue" : ""
                    }`}
                    onClick={() => setInviteLightBox(true)}
                    style={{ cursor: "pointer" }} // Make the Invite icon clickable
                  >
                    <Invite
                      className={`${InviteLightBox ? "color-blue" : ""}`}
                    />
                    <div
                      className={`icon-color ${
                        InviteLightBox ? "color-blue" : ""
                      }`}
                    >
                      Invite
                    </div>
                  </div>
                  <div
                    className="icon-20px flex-center-between icon-textGap-6px"
                    onClick={(event) => {
                      setAnchorElPopover(event.currentTarget);
                    }}
                  >
                    <Member
                      className={`${anchorElPopover ? "color-blue" : ""}`}
                    />
                    <div
                      className={`icon-color ${
                        anchorElPopover ? "color-blue" : ""
                      }`}
                    >
                      Member
                    </div>
                  </div>
                </>
              )}
              <Popover
                open={Boolean(anchorElPopover)}
                anchorEl={anchorElPopover}
                onClose={handlePopoverClose} // Use the handle function for closing
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                slotProps={{
                  paper: {
                    sx: { height: "250px" }, // Set height here
                  },
                }}
              >
                <div style={{ width: "350px" }}>
                  <h6 className="my-4 text-center">Family Members</h6>
                  <IconButton
                    className="m-0 p-0"
                    style={{ position: "absolute", top: "16px", right: "16px" }}
                    onClick={handlePopoverClose} // Use the same handler for both close button and popover closing
                  >
                    <CloseRoundedIcon />
                  </IconButton>
                  <div className="group_card_adding_memb w-100">
                    {unverifiedMembers?.length > 0 ? (
                      <>
                        {unverifiedMembers?.map((member, index) => (
                          <div
                            className="p-3 person_details flex-center-between"
                            key={index}
                          >
                            <div className="profile_name_details d-flex align-items-center gap-2">
                              <div
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  position: "relative",
                                }}
                              >
                                <Avatar
                                  src={member?.userDetails?.profile_url}
                                  alt={member?.userDetails?.first_name}
                                />
                              </div>
                              <div className="d-flex flex-column">
                                <div>{member?.userDetails?.first_name}</div>
                                <div>{member?.userDetails?.email}</div>
                              </div>
                            </div>

                            {/* Invite or Resend Button */}
                            {member?.userDetails?.is_verified === 0 ? (
                              <Button
                                variant="contained"
                                sx={{ backgroundColor: "#0044c6" }}
                                onClick={() =>
                                  handleInviteClick(member?.userDetails?.email)
                                }
                              >
                                {member?.send ? "RESEND" : "REINVITE"}
                              </Button>
                            ) : null}
                          </div>
                        ))}
                      </>
                    ) : (
                      <>No UnVerified Group Members</>
                    )}
                  </div>
                </div>
              </Popover>
              <div
                className="div-min-max me-3 d-flex align-items-center justify-content-around"
                style={{ width: "104px" }}
              >
                <div className={`iconBreadcrumb flex-center ms-0`}>
                  <FaCircleMinus className="icon-color" />
                </div>
                <div className="div icon-color">Zoom</div>
                <div className={`iconBreadcrumb flex-center ms-0 `}>
                  <FaPlusCircle className="icon-color" />
                </div>
              </div>
            </div>
            <div>
              <div className="family-tree">
                <style jsx>{`
                  .family-tree {
                    padding: 2rem;
                  }
                  .tree-container {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 4rem;
                    position: relative;
                  }
                  .root {
                    position: relative;
                  }
                  .root::after {
                    content: "";
                    position: absolute;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 0; /* Make the element width 0 */
                    height: 8.5rem;
                    border-left: 2px dashed #0044c6;
                  }
                  .parents-container {
                    display: flex;
                    position: relative;
                    align-items: center;
                    gap: ${father && mother ? "12rem" : "0"};
                  }
                  .parents-container::after {
                    content: "";
                    position: absolute;
                    bottom: -6.5rem;
                    left: 50%;
                    transform: translateX(-50%);
                    height: 9rem;
                    width: 0; /* Make the element width 0 */
                    border-left: 2px dashed #0044c6;
                  }
                  .self-spouse-container {
                    display: flex;
                    gap: ${owner || spouse ? "12rem" : "0"};
                    position: relative;
                    align-items: center;
                  }
                  .connecting-line {
                    position: absolute;
                    top: 50%;
                    left: 16rem;
                    width: 12rem;
                    height: 2px;
                    border-bottom: 2px dashed #0044c6;
                    transform: translateY(-50%);
                  }
                  .children-section {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    position: relative;
                  }
                  .children-vertical-line {
                    width: 0; /* Make the element width 0 */
                    height: 8.5rem;
                    border-left: 2px dashed #0044c6;
                    margin-top: -7.5rem;
                  }
                  .children-container {
                    display: flex;
                    justify-content: center;
                    position: relative;
                    gap: 4rem;
                  }
                  .children-horizontal-line {
                    position: absolute;
                    top: 0;
                    left: 50%;
                    transform: translateX(-50%);
                    height: 2px;
                    border-bottom: 2px dashed #0044c6;
                    width: ${(kids.length - 1) * 20}rem;
                  }
                  .child-wrapper {
                    position: relative;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                  }
                  .child-vertical-line {
                    width: 2px;
                    height: 2rem;
                    border-left: 2px dashed #0044c6;
                  }
                  .member-card {
                    background: white;
                    border-radius: 1rem;
                    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
                    border: 1px solid #e2e8f0;
                    width: 16rem;
                    z-index: 10000;
                  }
                  .card-content {
                    padding: 1rem;
                    display: flex;
                    align-items: center;
                    gap: 1rem;
                  }
                  .avatar-wrapper {
                    position: relative;
                  }
                  .avatar-container {
                    position: relative;
                    width: 3rem;
                    height: 3rem;
                  }
                  .avatar {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    object-fit: cover;
                    border: 2px solid #e2e8f0;
                  }
                  .online-status {
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    width: 0.875rem;
                    height: 0.875rem;
                    background-color: #22c55e;
                    border-radius: 50%;
                    border: 2px solid white;
                  }
                  .member-info {
                    flex: 1;
                  }
                  .name-container {
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    margin-bottom: 0.25rem;
                  }
                  .name {
                    font-weight: 600;
                    font-size: 1rem;
                    color: #1e293b;
                  }
                  .role {
                    font-size: 0.875rem;
                    color: #64748b;
                  }
                `}</style>

                <div className="tree-container">
                  {/* Root */}
                  <div className="root">
                    <div
                      className={`profile-card-group level-1 d-flex align-items-center gap-2 p-2 ${
                        groupDetailsSideView ? "Sidebar" : ""
                      }`}
                      onClick={handleOpenGroupDetails}
                    >
                      <div className="leftside_image_groupTree">
                        <div className="img">
                          {console.log(
                            "groupData?.group_info?.group_image",
                            groupData?.group_info?.group_image
                          )}
                          <img
                            className="cover-image"
                            src={groupData?.group_info?.group_image || frame}
                            alt="groupName"
                          />
                        </div>
                      </div>
                      <div className="rightSide-Info d-flex flex-column">
                        <div
                          className="group_permissiions_options fw-bold"
                          style={{ fontSize: "16px" }}
                        >
                          {groupData?.group_info?.group_name}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Parents */}
                  {(father || mother) && (
                    <div
                      className={`parents-container ${
                        father && mother ? "both-parents" : ""
                      }`}
                    >
                      {father && (
                        <ProfileCard
                          isEdit={isEditable}
                          profile={father}
                          handleProfileClick={handleProfileClick}
                          handleDivClick={handleDivClick}
                        />
                      )}
                      {father && mother && <div className="connecting-line" />}
                      {mother && (
                        <ProfileCard
                          isEdit={isEditable}
                          profile={mother}
                          handleProfileClick={handleProfileClick}
                          handleDivClick={handleDivClick}
                        />
                      )}
                    </div>
                  )}

                  {/* Self and Spouse */}
                  <div className="self-spouse-container">
                    {owner && (
                      <ProfileCard
                        isEdit={isEditable}
                        profile={owner}
                        handleProfileClick={handleProfileClick}
                        handleDivClick={handleDivClick}
                      />
                    )}
                    {spouse && (
                      <>
                        <div className="connecting-line" />
                        {spouse && (
                          <ProfileCard
                            isEdit={isEditable}
                            profile={spouse}
                            handleProfileClick={handleProfileClick}
                            handleDivClick={handleDivClick}
                          />
                        )}
                      </>
                    )}
                  </div>

                  {/* Children Section */}
                  {kids?.length > 0 && (
                    <div className="children-section">
                      <div className="children-vertical-line" />
                      <div className="children-container">
                        {kids?.length > 1 && (
                          <div className="children-horizontal-line" />
                        )}
                        {kids?.map((child) => (
                          <div key={child.id} className="child-wrapper">
                            <div className="child-vertical-line" />
                            <ProfileCard
                              isEdit={isEditable}
                              handleProfileClick={handleProfileClick}
                              profile={child}
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {isLightboxOpen && (
          <Lightbox profile={selectedProfile} onClose={handleCloseLightbox} />
        )}
        {groupDetailsSideView && (
          <GroupDetailsSidebar
            groupData={groupData}
            setGroupData={setGroupData}
            handleClose={handleCloseSidebar}
            availableHeight1={availableHeight1}
            formatDateAndTime={formatDateAndTime}
            isGroupEdit={isEditable}
          />
        )}
        {groupMemberDelete && (
          <DeleteMember
            selectedMember={selectedMember}
            groupid={groupData?.group_id}
            handleClose={handleDeleteSidebar}
            availableHeight1={availableHeight1}
          />
        )}
        <AddMemberToGroupCard
          anchorEl={anchorEl}
          setAnchorEl={setAnchorEl}
          group_id={id}
          InviteLightBox={InviteLightBox}
          setInviteLightBox={setInviteLightBox}
          father={father}
          mother={mother}
          spouse={spouse}
        />

        {/* {isVisisble && <FamilyDashboard id={id} groupData={completeGroupData} />} */}
      </div>
    </>
  );
};

const GroupDetailsSidebar = ({
  groupData,
  setGroupData,
  handleClose,
  availableHeight1,
  isGroupEdit,
}) => {
  const { callApiFunction } = useApi();
  const { openSnackbar } = useQuantityContext();

  const dispatch = useDispatch();
  const [editGroupDetails, setEditGroupDetails] = useState({
    groupName: groupData?.group_info?.group_name,
    groupDesc: groupData?.group_info?.group_desc,
    profileUrl: groupData?.group_info?.group_image,
  });
  const [isEditing, setIsEditing] = useState(false); // Track if the fields are being edited
  const objectId = localStorage.getItem("objectId")?.trim();
  //  const navigate = useNavigate(); // Initialize useNavigate

  // Handle input changes by updating the appropriate field in the state object
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditGroupDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value, // Dynamically update the correct field
    }));
  };

  // Handle profile picture URL update (can be passed as a prop to updateProfileUrl)
  const handleProfileUrlChange = (newUrl) => {
    setEditGroupDetails((prevDetails) => ({
      ...prevDetails,
      profileUrl: newUrl,
    }));
  };

  // Function to call API and save the updated group details
  const handleSave = async () => {
    try {
      const viewerToken = localStorage.getItem("objectId")?.trim(); // Retrieve token from localStorage
      const apiKey = process.env.REACT_APP_API_KEY; // Get API key from environment variable

      const headers = {
        "x-api-key": apiKey,
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${viewerToken}`, // Add the token as Bearer
      };

      const formData = new FormData();

      formData.append("group_id", groupData?.group_id);
      formData.append("group_name", editGroupDetails?.groupName);
      formData.append("group_category", "FAMILY");
      formData.append("group_type", "FAMILY");
      formData.append("group_subname", "Family Group");
      formData.append("group_desc", editGroupDetails?.groupDesc);

      if (editGroupDetails.profileUrl) {
        try {
          const file = URL.createObjectURL(editGroupDetails?.profileUrl);
          const response = await fetch(file);
          const blob = await response.blob();
          formData.append("profile_pic", blob);
        } catch (error) {
          console.log("ERROR", error);
        }
      }

      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/card/group-card/update`,
        formData,
        { headers }
      );
      console.log("Group card Kaah checking part is ", response);
      if (response.status === 200) {
        openSnackbar("Group Edited Sucessfully!", "success");
        setGroupData({
          ...groupData,
          group_name: editGroupDetails?.groupName,
          group_desc: editGroupDetails?.groupDesc,
          group_image: response?.data?.data?.group_image,
        });
        await dispatch(getAllCardDetailsReducer());
        await dispatch(getAllCardInfoReducer());
        await callApiFunction("getGroupCardDetails", {
          id: groupData?.group_id,
        });

        setIsEditing(false); // Exit edit mode
        handleClose();
      } else {
        openSnackbar("Something wrong, Try Again Later!", "error");
        // console.error('Failed to update group details.');
        // Handle error case (e.g., show an error message to the user)
      }
    } catch (error) {
      openSnackbar("Something wrong, Try Again Later!", "error");
      // console.error('An error occurred while updating group details:', error);
      // Handle error (e.g., show an error message to the user)
    }
  };

  const handleDelete = async () => {
    try {
      // Example: API call to save the updated group details
      const response = await axios.delete(
        `card/group-card/delete/${groupData?.group_id}`,
        {
          headers: {
            Authorization: `Bearer ${objectId}`,
            "Content-Type": "application/json",
          },
        }
      );

      // console.log("Group card Kaah checking part is ", response);
      if (response.data.status === "SUCCESS") {
        openSnackbar("Group Deleted Sucessfully!", "success");
        await dispatch(getAllCardDetailsReducer());
        await dispatch(getAllCardInfoReducer());
        window.location.href = "/cards";
      } else {
        openSnackbar("Something wrong, Try Again Later!", "error");
        // console.error('Failed to update group details.');
        // Handle error case (e.g., show an error message to the user)
      }
    } catch (error) {
      openSnackbar("Something wrong, Try Again Later!", "error");
      // console.error('An error occurred while updating group details:', error);
      // Handle error (e.g., show an error message to the user)
    }
  };

  const handleEditClick = () => {
    setIsEditing(true); // Enter edit mode
  };

  return (
    <div
      className="group-details-sidebar"
      style={{
        maxHeight: `${availableHeight1}px`,
        minHeight: `${availableHeight1}px`,
        overflowY: "auto",
        scrollbarWidth: "thin",
      }}
    >
      <IconButton
        onClick={handleClose}
        className="lightbox-close2"
        style={{ position: "absolute", top: "4px", right: "4px" }}
      >
        <CloseIcon />
      </IconButton>

      <div className="group-details-content mx-2">
        <div className="group-details-header">
          <h6 className="mt-4 text-center">
            {groupData?.group_info?.group_name}
          </h6>

          <ProfilePicEditComponent
            fieldName="profile_picture"
            value={editGroupDetails?.profileUrl}
            acceptedFormats="image/*"
            onChange={handleProfileUrlChange}
            isEditable={isGroupEdit}
          />
        </div>
        {isEditing ? (
          // Render TextField when editing the group name
          <TextField
            name="groupName"
            value={editGroupDetails?.groupName}
            onChange={handleInputChange}
            fullWidth
            variant="outlined"
            label="Group Name"
            inputProps={{ maxLength: 24 }}
          />
        ) : (
          // Render static text when not editing
          <div className="d-block group_card_details text-center">
            Title: {groupData?.group_info?.group_name}
          </div>
        )}

        {isEditing ? (
          // Render TextField when editing the group description
          <TextField
            className="mt-2"
            name="groupDesc"
            value={editGroupDetails?.groupDesc}
            onChange={handleInputChange}
            fullWidth
            variant="outlined"
            label="Group Description"
            multiline
            rows={3}
            inputProps={{ maxLength: 24 }} // Adjust rows based on the desired height
          />
        ) : (
          <p className="d-block group_card_details text-center">
            {groupData?.group_info?.group_desc}
          </p>
        )}

        <div className="group-metaInfo flex-center gap-3 mt-3">
          <div className="icon-20px d-flex align-items-center">
            <AccessTimeFilledIcon
              className="icon-color"
              style={{ marginRight: "6px", color: "#6c757d" }}
            />
            <span className="sub-heading-style-16">
              {groupData?.formattedTime}
            </span>
          </div>
          <div className="icon-20px d-flex align-items-center">
            <CalendarTodayIcon
              className="icon-color"
              style={{ marginRight: "6px", color: "#6c757d" }}
            />
            <span className="sub-heading-style-16">
              {groupData?.formattedDate}
            </span>
          </div>
        </div>

        {isGroupEdit && (
          <div className="flex-center mt-3">
            {isEditing ? (
              <Button
                variant="contained"
                onClick={handleSave}
                sx={{ backgroundColor: "#0044C6" }}
              >
                Save
              </Button>
            ) : (
              <>
                <Button
                  variant="contained"
                  onClick={handleEditClick}
                  sx={{ backgroundColor: "#0044C6" }}
                >
                  Edit
                </Button>

                <Button
                  variant="contained"
                  onClick={handleDelete}
                  sx={{ backgroundColor: "#0044C6", marginLeft: "5px" }}
                >
                  Delete
                </Button>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

const DeleteMember = ({
  selectedMember,
  groupid,
  handleClose,
  availableHeight1,
}) => {
  const dispatch = useDispatch();
  // console.log("Selected Member", selectedMember, "groupdata", groupid);
  const [selectedId, setSelectedId] = useState(selectedMember?.user_ref_id);

  const handleDeleteMember = async () => {
    try {
      const payload = {
        group_id: groupid,
        member_ids: [selectedId],
      };

      console.log("payloadpayload", payload);
      const response = await dispatch(deleteGroupcardMemberReducer(payload));
      console.log("REsponse", response);
      if (response?.payload?.status === 200) {
        await dispatch(getFamilyCardReducer(groupid));
        handleClose();
      }
    } catch (error) {
      console.log("API ERROR", error);
    }
  };

  return (
    <div
      className="group-details-sidebar"
      style={{
        maxHeight: `${availableHeight1}px`,
        minHeight: `${availableHeight1}px`,
        overflowY: "auto",
        scrollbarWidth: "thin",
      }}
    >
      <IconButton
        onClick={handleClose}
        className="lightbox-close2"
        style={{ position: "absolute", top: "4px", right: "4px" }}
      >
        <CloseIcon />
      </IconButton>

      <div className="group-details-content mx-2">
        <div className="group-details-header d-flex flex-column align-items-center">
          <h6 className="mt-4 text-center">{selectedMember?.relationship}</h6>
          <Avatar
            sx={{ width: 120, height: 120 }}
            alt={selectedMember?.userDetails?.first_name}
            src={selectedMember?.userDetails?.profile_url}
          />
        </div>

        <div className="d-block group_card_details text-center">
          Name: {selectedMember?.userDetails?.first_name}
        </div>

        <p
          className="d-block group_card_details text-center"
          style={{ fontSize: "16px" }}
        >
          {selectedMember?.role}
        </p>

        {selectedMember?.relationship === "OWNER" ? (
          <p className="text-center">Can't delete the Admin.</p>
        ) : (
          <div className="flex-center mt-3">
            <>
              <Button
                variant="contained"
                onClick={handleClose}
                sx={{ backgroundColor: "#0044C6" }}
              >
                CANCEL
              </Button>

              <Button
                variant="contained"
                onClick={handleDeleteMember}
                sx={{ backgroundColor: "#0044C6", marginLeft: "5px" }}
              >
                Delete
              </Button>
            </>
          </div>
        )}
      </div>
    </div>
  );
};
const Lightbox = ({ profile, onClose }) => {
  // Currently It is Not been Used for Some reason
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    name: profile.userDetails.first_name,
    role: profile.relationship,
    admin: profile.role === "ADMIN",
  });

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleSaveClick = () => {
    // Implement save logic here, maybe an API call to update the user
    console.log("Saved data:", formData);
    setIsEditing(false);
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="lightbox">
      <button className="close-btn" onClick={onClose}>
        X
      </button>
      {/* COMMENT AS IT IS NOT cOnfirmedHow the  Admin and Member Should look into the Things*/}
      {/*}
       {!isEditing ? (
        <div>
          <img src={profile.image} alt={profile.name} />
          <h3>{profile.name}</h3>
          <p>{profile.role}</p>
          <div>
            <button onClick={handleEditClick}>Edit</button>
            <button onClick={onClose}>Remove</button>
          </div>
        </div>
      ) : (
        <div className="edit-mode">
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
          />
          <input
            type="text"
            name="role"
            value={formData.role}
            onChange={handleInputChange}
          />
          <label>
            Admin:
            <input
              type="checkbox"
              name="admin"
              checked={formData.admin}
              onChange={() =>
                setFormData((prev) => ({ ...prev, admin: !prev.admin }))
              }
            />
          </label>
          <button onClick={handleSaveClick}>Save</button>
          <button onClick={onClose}>Cancel</button>
        </div>
      )} */}
    </div>
  );
};

export default GroupCard;
